import { Box, FormControlLabel, Switch, Typography } from "@mui/material";
import { startToast, updateToastSuccess, updateToastError } from "../../../utils/notification-loading";
import API from "../../../api";

const Privacy = ({privacy, setPrivacy}) => {

  const handeChangePrivacy = (value) => {
    startToast();
    API.setPrivacy({privacy: value ? 1 : 0}).then(() => {
      setPrivacy(value);
      updateToastSuccess("Privacy changed successfully");
    }).catch(() => {
      updateToastError("Error while changing privacy");
    })
  }

  return(
    <Box sx={{backgroundColor: 'rgba(69, 144, 149, 0.05)', borderRadius: 2, border: '1px solid rgba(69, 144, 149, 0.1)', p: 3}}>
      <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#449095', mb: 2 }}>Privacy settings</Typography>
      <Typography>Do you allow your reseller to access your data?</Typography>
      <FormControlLabel label={privacy ? "Yes" : "No"} control={<Switch checked={privacy} onChange={(e) => handeChangePrivacy(e.target.checked)} />} />
    </Box>
  )
}

export default Privacy;